"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeaserPromoBtLimitStatusType = exports.REVOLVING_TEASER_PROMO_TYPES = exports.TeaserPromoType = void 0;
/** @TranslateToPython @TranslateToEnum */
var TeaserPromoType;
(function (TeaserPromoType) {
    TeaserPromoType["NO_TEASER_PROMO"] = "NO_TEASER_PROMO";
    TeaserPromoType["TEASER_ZERO_APR_REVOLVING"] = "TEASER_ZERO_APR_REVOLVING";
    TeaserPromoType["TEASER_PROMO_BALANCE_TRANSFER_REVOLVING"] = "TEASER_PROMO_BALANCE_TRANSFER_REVOLVING";
    TeaserPromoType["TEASER_PROMO_ZERO_APR_WITH_BT_FEE_BALANCE_TRANSFER_REVOLVING_1_MONTH"] = "TEASER_PROMO_ZERO_APR_WITH_BT_FEE_BALANCE_TRANSFER_REVOLVING_1_MONTH";
    TeaserPromoType["TEASER_PROMO_ZERO_APR_WITH_DIFFERENT_INITAL_BT_FEE_REVOLVING"] = "TEASER_PROMO_ZERO_APR_WITH_DIFFERENT_INITAL_BT_FEE_REVOLVING";
    TeaserPromoType["TEASER_PROMO_ZERO_PCT_BT_FEE"] = "TEASER_PROMO_ZERO_PCT_BT_FEE";
    TeaserPromoType["TEASER_PROMO_ZERO_PCT_BT_FEE_AND_2PCT_BT_CASHBACK"] = "TEASER_PROMO_ZERO_PCT_BT_FEE_AND_2PCT_BT_CASHBACK";
    TeaserPromoType["HELOC_REFI_LOWER_APR_FOR_PAYOFF_SIP"] = "HELOC_REFI_LOWER_APR_FOR_PAYOFF_SIP";
    TeaserPromoType["HELOC_REFI_AVEN_CASH_LOWER_APR_FOR_UPFRONT_DRAW_SIP"] = "HELOC_REFI_AVEN_CASH_LOWER_APR_FOR_UPFRONT_DRAW_SIP";
    TeaserPromoType["TEASER_PROMO_BALANCE_TRANSFER_WITH_LIMIT_REVOLVING"] = "TEASER_PROMO_BALANCE_TRANSFER_WITH_LIMIT_REVOLVING";
    TeaserPromoType["TEASER_PROMO_BALANCE_SWEEP_ZERO_APR_SIP"] = "TEASER_PROMO_BALANCE_SWEEP_ZERO_APR_SIP";
})(TeaserPromoType || (exports.TeaserPromoType = TeaserPromoType = {}));
// these are teasers for which we might have multiple rows in the AvenBalanceTransferTeaser table that
// all correspond to a *single* Corecard PlanId. When expiring a teaser of this type, we need to mark *all*
// the teaser rows for that account and teaser type as expired.
exports.REVOLVING_TEASER_PROMO_TYPES = [
    TeaserPromoType.TEASER_ZERO_APR_REVOLVING,
    TeaserPromoType.TEASER_PROMO_BALANCE_TRANSFER_REVOLVING,
    TeaserPromoType.TEASER_PROMO_ZERO_APR_WITH_BT_FEE_BALANCE_TRANSFER_REVOLVING_1_MONTH,
    TeaserPromoType.TEASER_PROMO_ZERO_APR_WITH_DIFFERENT_INITAL_BT_FEE_REVOLVING,
    TeaserPromoType.TEASER_PROMO_BALANCE_TRANSFER_WITH_LIMIT_REVOLVING,
];
var TeaserPromoBtLimitStatusType;
(function (TeaserPromoBtLimitStatusType) {
    TeaserPromoBtLimitStatusType["NO_LIMIT"] = "NO_LIMIT";
    TeaserPromoBtLimitStatusType["REMAINING"] = "REMAINING";
    TeaserPromoBtLimitStatusType["REACHED"] = "REACHED";
    TeaserPromoBtLimitStatusType["EXCEEDED"] = "EXCEEDED";
})(TeaserPromoBtLimitStatusType || (exports.TeaserPromoBtLimitStatusType = TeaserPromoBtLimitStatusType = {}));
